let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("abVVB")).then(() => parcelRequire('hrqJ0'));